import * as React from 'react';

export const ColumnDisplayIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='123'
    height='123'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path
      d='M6.49968 9.49915L9.49968 9.49938H12.4997V15.4994H6.49968V9.49915ZM6.49968 17.5002H12.4997L12.4998 23.5002H6.49977L6.49968 17.5002ZM14.9997 9.49938H20.9997V15.4994H14.9997V9.49938ZM14.9997 17.5004L20.9997 17.5002L20.9998 23.5002L14.9998 23.5004L14.9997 17.5004ZM16.4997 10.9992V13.9992H19.4997V10.9992H16.4997ZM16.4997 19L16.4998 22H19.4998L19.4997 19H16.4997ZM7.99968 10.9992V13.9992H10.9997V10.9992H7.99968ZM7.99968 19L7.99977 22H10.9998L10.9997 19H7.99968Z'
      fill='#004F9F'
    />
    <path
      d='M3.49991 9.5L3.49991 15.5H1.99902L1.99903 9.5H3.49991Z'
      fill='#004F9F'
    />
    <path
      d='M3.49991 17.5005L3.5 23.5004H1.99912L1.99903 17.5005H3.49991Z'
      fill='#004F9F'
    />
    <path
      d='M14.9998 1L21.0012 5L14.9998 8.5V7L17.5008 5.6L1.99903 5.55V4.1L17.5008 4.151L14.9998 2.5V1Z'
      fill='#004F9F'
    />
  </svg>
);
